import { useEffect, useState } from "react";
import AdminShell, { ADMIN_NAV } from "../components/admin/AdminShell";
import LoginView from "../components/admin/LoginView";
import ChangePasswordView from "../components/admin/ChangePasswordView";
import DashboardView from "../components/admin/DashboardView";
import PipelineView from "../components/admin/PipelineView";
import RecruitsView from "../components/admin/RecruitsView";
import AgentsView from "../components/admin/AgentsView";
import AdminsView from "../components/admin/AdminsView";
import RecruitDrawer from "../components/admin/RecruitDrawer";
import NotificationsSheet, { PushBanner, usePush } from "../components/admin/NotificationsSheet";
import useCrm from "../components/admin/useCrm";
import useAdminTeam from "../components/admin/useAdminTeam";
import { useLeadDeepLink } from "../components/admin/useLeadDeepLink";

export default function AdminPage() {
  const crm = useCrm({ tokenKey: "breeze_admin_token", role: "admin" });
  const team = useAdminTeam(crm.api, !!crm.token);
  const [view, setView] = useState("dashboard");
  const [selectedId, setSelectedId] = useState(null);
  const [pwOpen, setPwOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const { leads, agents, stats, user } = crm;
  const push = usePush(crm.api, !!crm.token);
  useLeadDeepLink(leads, setSelectedId);

  useEffect(() => { if (!crm.token) setNotifOpen(false); }, [crm.token]);

  if (!crm.token) return <LoginView onLogin={crm.login} variant="admin" />;
  if (user?.must_change_password) return <ChangePasswordView forced onSubmit={crm.changePassword} onLogout={crm.logout} userName={user.name} />;

  const selected = leads.find((l) => l.id === selectedId) || null;
  const counts = { pipeline: leads.filter((l) => !["Onboarded", "Lost"].includes(l.status)).length, recruits: leads.length, agents: agents.length, admins: team.admins.length };
  const newCount = leads.filter((l) => l.status === "New").length;

  return (
    <AdminShell nav={ADMIN_NAV} brandLabel="Recruiting CRM" view={view} setView={setView} counts={counts} user={user} loading={crm.loading}
      onRefresh={crm.load} onLogout={crm.logout} onChangePassword={() => setPwOpen(true)} onNotifications={() => setNotifOpen(true)} pushOn={push.subscribed} newCount={newCount}>
      {view === "dashboard" && (
        <div className="space-y-4">
          <PushBanner push={push} onOpen={() => setNotifOpen(true)} />
          <DashboardView stats={stats} leads={leads} onOpen={setSelectedId} goTo={setView} />
        </div>
      )}
      {view === "pipeline" && <PipelineView leads={leads} onMove={crm.setStage} onOpen={setSelectedId} />}
      {view === "recruits" && <RecruitsView leads={leads} agents={agents} onOpen={setSelectedId} onStage={crm.setStage} onDelete={crm.deleteLead} onDeleteMany={crm.deleteLeads} />}
      {view === "agents" && <AgentsView agents={agents} leaderboard={stats?.leaderboard} onAdd={crm.addAgent} onInvite={crm.inviteAgent} onToggle={crm.toggleAgent} onRemove={crm.removeAgent} />}
      {view === "admins" && <AdminsView admins={team.admins} me={user} onAdd={team.addAdmin} onInvite={team.inviteAdmin} onRemove={team.removeAdmin} />}
      <RecruitDrawer lead={selected} agents={agents} onClose={() => setSelectedId(null)} onStage={crm.setStage} onReassign={crm.reassign} onLoadEmails={crm.getEmails}
        onAddNote={crm.addNote} onDeleteNote={crm.deleteNote} onDelete={async (id) => { if (await crm.deleteLead(id)) setSelectedId(null); }} />
      {pwOpen && <ChangePasswordView onSubmit={crm.changePassword} onClose={() => setPwOpen(false)} />}
      {notifOpen && <NotificationsSheet push={push} role="admin" onClose={() => setNotifOpen(false)} />}
    </AdminShell>
  );
}
